var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon2Way01 = function SvgIcon2Way01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_2_way-01_svg2__a",
    x1: 70.14,
    x2: -20.51,
    y1: -35.73,
    y2: 66.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_2_way-01_svg2__a",
    id: "icon_2_way-01_svg2__b",
    x1: 132.62,
    x2: 41.96,
    y1: 19.52,
    y2: 122.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_2_way-01_svg2__a",
    id: "icon_2_way-01_svg2__c",
    x1: 101.38,
    x2: 10.73,
    y1: -8.11,
    y2: 94.42
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10.64 40.38c.3.47.82.75 1.37.75.56 0 1.07-.28 1.37-.75l5.45-8.39c.4-.62.34-1.44-.15-1.99-.32-.35-.78-.55-1.26-.54h-2.94c-.84-.01-1.54.63-1.62 1.46-.06.86.6 1.61 1.46 1.67h.39l-2.7 4.16-2.7-4.16c1.15 0 2.09-.93 2.09-2.09v-3.44c0-5.2 4.21-9.41 9.41-9.41h4.3c.84.01 1.54-.63 1.62-1.46.06-.86-.6-1.61-1.46-1.67h-4.46c-6.93 0-12.54 5.61-12.54 12.54v2.4H6.61c-.48 0-.94.19-1.26.54-.5.55-.56 1.37-.16 1.99z",
    style: {
      fill: "url(#icon_2_way-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.36 59.62c-.37-.56-1.04-.85-1.7-.71-.45.1-.84.37-1.08.76l-5.42 8.35c-.43.66-.33 1.54.24 2.08.32.3.74.46 1.17.45h2.93c.84.01 1.55-.63 1.62-1.47.05-.86-.6-1.61-1.47-1.66h-.39l2.69-4.15h.01l2.68 4.15c-1.14 0-2.07.93-2.07 2.07v3.45c0 5.2-4.22 9.42-9.42 9.42h-3.7c-.84-.01-1.55.63-1.62 1.47-.05.86.6 1.61 1.47 1.66h3.86c6.93 0 12.55-5.62 12.55-12.55v-2.38h1.65c.43 0 .85-.15 1.17-.45.57-.55.67-1.42.24-2.08l-5.45-8.39Z",
    style: {
      fill: "url(#icon_2_way-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 14.75v-1.54c0-2.99-2.43-5.41-5.42-5.42H35.72c-2.99 0-5.41 2.43-5.42 5.42v30.26H5.42C2.43 43.47.01 45.9 0 48.89V86.8c0 2.99 2.43 5.41 5.42 5.42h58.86c2.99 0 5.41-2.43 5.42-5.42V56.54h24.89c2.99 0 5.41-2.43 5.42-5.42V14.75Zm-64.28-3.83h58.86c1.26 0 2.28 1.02 2.29 2.29v.74L69.35 32.91a7.45 7.45 0 0 1-8.4 0L33.43 13.95v-.74c0-1.26 1.02-2.28 2.29-2.29M5.42 46.6h58.86c1.26 0 2.28 1.02 2.29 2.29v.74L39.05 68.59a7.45 7.45 0 0 1-8.4 0L3.13 49.62v-.74c0-1.26 1.02-2.28 2.29-2.29Zm61.15 40.19c0 .21-.03.41-.09.61L50.4 69.26c-.57-.65-1.56-.71-2.21-.13-.65.57-.71 1.56-.13 2.21l15.73 17.74H5.92l15.72-17.74c.57-.65.51-1.64-.13-2.21-.65-.57-1.64-.51-2.21.13L3.22 87.4c-.06-.2-.08-.4-.09-.61V53.42l25.74 17.74c3.6 2.46 8.35 2.46 11.95 0l25.74-17.74v33.37Zm3.13-37.91c0-2.99-2.43-5.41-5.42-5.42H45.03l6.92-7.81c.57-.65.51-1.64-.13-2.21-.65-.57-1.64-.51-2.21.13l-8.59 9.69c-.05.06-.1.13-.15.2h-7.44V17.74l25.74 17.74c3.6 2.46 8.35 2.46 11.95 0l25.74-17.74v33.37c0 .21-.03.41-.09.61L80.69 33.58c-.57-.65-1.56-.71-2.21-.13-.65.57-.71 1.56-.13 2.21L94.08 53.4H69.69v-4.52Z",
    style: {
      fill: "url(#icon_2_way-01_svg2__c)"
    }
  }));
};
export default SvgIcon2Way01;